import React from 'react'
import Modal from 'react-modal'
const DeletePopup = ({ isOpen, toggleMenu, handleDelete }) => {
    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={toggleMenu}
            className={`fixed inset-0 flex items-center justify-center`}
            overlayClassName="fixed inset-0 bg-black bg-opacity-50 transition-opacity"
            shouldCloseOnOverlayClick
            shouldCloseOnEsc
        >
            <div
                className="bg-blue-400 shadow-lg rounded-lg w-80 p-6 flex flex-col items-center justify-center"
            >
                <h2 className="text-lg font-semibold text-white mb-4">Confirm Delete</h2>
                <p className="text-sm text-white mb-6">Are you sure you want to delete this item?</p>
                <div className="flex gap-4">
                    <button
                        className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
                        onClick={handleDelete}
                    >
                        Delete
                    </button>
                    <button
                        className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
                        onClick={toggleMenu}
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </Modal>

    )
}

export default DeletePopup
